var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReporting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 26,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.54547 14.8571H11.8182V16.7143H4.54547V14.8571Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54547 10.2143H15.4546V12.0714H4.54547V10.2143Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54547 19.5H9.09093V21.3571H4.54547V19.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1818 2.78571H15.4545V1.85714C15.4545 1.3646 15.263 0.892226 14.922 0.543944C14.581 0.195663 14.1186 0 13.6364 0H6.36364C5.88142 0 5.41896 0.195663 5.07799 0.543944C4.73701 0.892226 4.54545 1.3646 4.54545 1.85714V2.78571H1.81818C1.33597 2.78571 0.873508 2.98138 0.532533 3.32966C0.191558 3.67794 0 4.15031 0 4.64286V24.1429C0 24.6354 0.191558 25.1078 0.532533 25.4561C0.873508 25.8043 1.33597 26 1.81818 26H18.1818C18.664 26 19.1265 25.8043 19.4675 25.4561C19.8084 25.1078 20 24.6354 20 24.1429V4.64286C20 4.15031 19.8084 3.67794 19.4675 3.32966C19.1265 2.98138 18.664 2.78571 18.1818 2.78571V2.78571ZM6.36364 1.85714H13.6364V5.57143H6.36364V1.85714ZM18.1818 24.1429H1.81818V4.64286H4.54545V7.42857H15.4545V4.64286H18.1818V24.1429Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporting);
export default __webpack_public_path__ + "static/media/reporting.4c6108046a1a640cf01b960d1f098c6a.svg";
export { ForwardRef as ReactComponent };